import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { getEventCollection } from "../../actions";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

let eventsetupData = {};
const EventCollectionPreview = (props) => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

    const customHtml = `
    <div class="registration-collection-preview">
    <div class="registration-collection">
    <div class="registration-collection-header d-flex align-items-center" style="{#dynamic_header_background#};">
        <div class="collection-logo">
        {#logo#}
        </div>
        <div class="collection-content ">
        <h2 style="color: {#headerTextColor#};">{#headerText#}</h2>
        <Button style="color: {#buttonColor#};{#buttonColor_background#};">{#buttonText#}</Button>
        </div>
    </div>
    <div class="registration-collection-body">
        <div class="registration-collection-inset">
        <h4 style="color: {#bodyTextColor#};">
            {#bodyText#}
        </h4>
        <div class="registration-collection-content">
            {#dynamicContent#}
        </div>
        </div>
    </div>
    <div class="footer-statement">
        <p style="color: {#footerTextColor#};">{#footerText#}</p>
    </div>
    </div>
    </div>`;

    let defaultHtmlTokens = {
        dynamic_header_background: `background-image: url(${path_image}/registration-collection-header.png)`,
        headerTextColor: '#ffffff',
        buttonColor: '#ffffff',
        buttonColor_background: 'background-color:#0066BE',
        bodyTextColor: '#0066BE',
        footerTextColor: '#70899E',
        headerText: 'Click to register and receive the content described below',
        buttonText: 'Register',
        bodyText: '<strong>Docintel Portal</strong> is a free service intended for Health Care Professionals. <strong>Please review the content you will receive before registering.</strong>',
        footerText: 'The information in this asset has been developed for an international audience. Accordingly, it may contain information on products and/or indications that are not approved in your country. Please refer to your country-specific approved product labelling for important safety information before prescribing, as licenses and licensing conditions may vary from country to country.',
        logo: `<img src="${path_image}docintel-portal.png" alt="Logo" />`,
        selectedContent: eventsetupData?.setUpData?.selectedContent ? eventsetupData?.setUpData?.selectedContent : [],
    }

    let defaultFormValues = {
        headerBackType: 'image',
        headerBackgroundColor: '#004A89',
        headerBackgroundImage: `${path_image}/registration-collection-header.png`,
        showHeaderLogo: true,
        headerLogoUrl: `${path_image}/docintel-portal.png`,
        headerLogoWidth: 100,
        headerText: 'Click to register and receive the content described below',
        headerTextColor: '#ffffff',
        buttonColor_background: '#0066BE',
        buttonText: "Register",
        showBodySection: true,
        bodyText: '<strong>Docintel Portal</strong> is a free service intended for Health Care Professionals. <strong>Please review the content you will receive before registering.</strong>',
        bodyTextColor: '#0066BE',
        showFooterSection: true,
        footerText: 'The information in this asset has been developed for an international audience. Accordingly, it may contain information on products and/or indications that are not approved in your country. Please refer to your country-specific approved product labelling for important safety information before prescribing, as licenses and licensing conditions may vary from country to country.',
        footerTextColor: '#70899E',
    };

    const [htmlTokens, setHtmlTokens] = useState([]);
    const [formValues, setFormValues] = useState(eventsetupData?.setUpData?.formData ? eventsetupData?.setUpData?.formData : defaultFormValues);

    useEffect(() => {
        if (eventsetupData?.setUpData?.templateHtml) {
            const updatedTemplateHtml = {
                ...eventsetupData.setUpData.templateHtml,
                selectedContent: eventsetupData?.setUpData?.selectedContent ? eventsetupData?.setUpData?.selectedContent : [],
            };
            setHtmlTokens(updatedTemplateHtml);
        } else {
            setHtmlTokens(defaultHtmlTokens);
        }
    }, [eventsetupData]);

    const renderHtmlWithTokens = (template, tokens) => {
        let result = template;
        Object.entries(tokens).forEach(([key, value]) => {
            if (key !== 'selectedContent') {
                result = result.replaceAll(`{#${key}#}`, value);
            }
        });
        result = result.replace('{#dynamicContent#}', renderDynamicContent(tokens.selectedContent));
        return result;
    };

    const renderDynamicContent = (items = []) => {
        return items
            .map((item) => {
            return `
                <div class="registration-collection-content-box">
                <div class="collection-img">
                    <img src="${item?.cover_img}" alt="" />
                </div>
                <div class="collection-text">
                    <p>${item.title}</p>
                    <span>${item.pdf_sub_title}</span>
                    <div class="option-included"></div>
                </div>
                </div>
            `;
            })
            .join('');
    };

    useEffect(() => {
        setHtmlTokens((prev) => ({
            ...prev,
            ... {
                headerText: formValues.headerText,
                headerTextColor: formValues.headerTextColor,
            },
            ...(formValues.showBodySection && {
                bodyText: formValues.bodyText,
                bodyTextColor: formValues.bodyTextColor,
            }),
            ...(formValues.showFooterSection && {
                footerText: formValues.footerText,
                footerTextColor: formValues.footerTextColor,
            }),
            ...(formValues.buttonText && {
                buttonText: formValues.buttonText,
            }),
            ...(formValues.buttonColor_background && {
                buttonColor_background: `background-color:${formValues.buttonColor_background}`,
            }),
        }));
    }, [
        formValues.headerText,
        formValues.headerTextColor,
        formValues.bodyText,
        formValues.bodyTextColor,
        formValues.footerText,
        formValues.footerTextColor,
        formValues.buttonText,
        formValues.buttonColor_background,
        formValues.showBodySection,
        formValues.showFooterSection,
    ]);

    return(
        <>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
             <Col className="right-sidebar custom-change event-collection">
                <div className="container-fluid">
                    <div className="row">
                    <div className="top-header sticky"><div className="page-title d-flex">
                    <div className="col-12 col-md-1"><div className="header-btn-left">
                        <Link to="/webinar/event/event-collection">
                            <button className="btn btn-primary btn-bordered back">
                                Back
                            </button>
                        </Link>
                        </div></div>
                    </div></div>
                        <div
                            dangerouslySetInnerHTML={{
                            __html: renderHtmlWithTokens(customHtml, htmlTokens),
                            }}
                        />
                        {/* {
                            collectionData?.selectedContent?.length > 0 && (
                                <div className="registration-collection">
                                    <div className="registration-collection-header d-flex align-items-center">
                                        <div className="collection-logo">
                                            <img src={path_image + "docintel-portal.png"} alt="Logo" />
                                        </div>
                                        <div className="collection-content ">
                                            <h2>Click to register and receive the content described below</h2>
                                            <Button>Register</Button>
                                        </div>
                                    </div>
                                    <div className="registration-collection-body">
                                        <div className="registration-collection-inset">
                                        <h4><strong>Docintel Portal</strong> is a free service intended for Health Care Professionals. <strong>Please review the content you will receive before registering.</strong></h4>
                                        <div className="registration-collection-content">
                                                <div className="registration-collection-content-box" key={index}>
                                                    <div className="collection-img"><img src={item?.cover_img} alt=""/></div>
                                                    <div className="collection-text">
                                                        <p>{item?.title}</p>
                                                        <span>{item?.pdf_sub_title}</span>
                                                        <div className="option-included">
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="footer-statement">
                                        <p>The information in this asset has been developed for an international audience. Accordingly, it may contain information on products and/or indications that are not approved in your country. Please refer to your country-specific approved product labelling for important safety information before prescribing, as licenses and licensing conditions may vary from country to country.</p>
                                    </div>
                                </div>
                            )
                        } */}
                    </div>
                </div>
             </Col>
        </>
    );
}

const mapStateToProps = (state) => {
  eventsetupData = state?.getEventCollection;
  return state;
};

export default connect(mapStateToProps, { getEventCollection: getEventCollection })(
  EventCollectionPreview
);

